export default __webpack_public_path__ + "static/media/media.3399b4e6.svg";